
function Error ( { message } )
{
    return  <p className="p-2 mb-2 font-bold bg-pgred p-2 text-pgwhite rounded-lg">
                {message}
            </p>
}

export default Error;